import type { ViewPosition } from '@/features/interactive-viewer-v2/types/types';

import { SafetyIssueForm } from './SafetyIssueForm';

interface SafetyHotspotFormProps {
  photoId: number;
  projectId: number | undefined;
  viewPosition: ViewPosition;
  hotspotId?: number;
  onSuccess: () => void;
  onCancel: () => void;
}

export const SafetyHotspotForm = ({
  photoId,
  projectId,
  viewPosition,
  hotspotId,
  onSuccess,
  onCancel,
}: SafetyHotspotFormProps) => {
  if (!projectId) {
    return <p className="py-4 text-sm text-destructive">No project context is available.</p>;
  }

  return (
    <SafetyIssueForm
      projectId={projectId}
      photoId={photoId}
      viewPosition={viewPosition}
      hotspotId={hotspotId}
      onSuccess={onSuccess}
      onCancel={onCancel}
    />
  );
};
